<template>

    <DetailsSection class="step">
        <template slot="header">
            <media-only desktop>
                        <span class="step-number">
                        </span>
            </media-only>
            {{$t('Cancellation.header.bankAccount')}}
        </template>

        <p>{{$t('Cancellation.cancel.bankAccountText')}}</p>

        <div class="form-row">
            <div class="form-group col-sm-6">
                <input type="text" v-model.lazy="cancellation.firstname" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.firstname')"
                       :aria-label="$t('Generic.firstname')"
                        maxlength="40"/>
            </div>
            <div class="form-group col-sm-6">
                <input type="text" v-model.lazy="cancellation.lastname" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.lastname')"
                       :aria-label="$t('Generic.lastname')"
                       maxlength="40"/>
            </div>
            <div class="form-group col-sm-12">
                <input type="text" v-model.lazy="cancellation.iban" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.iban')"
                       :aria-label="$t('Generic.iban')"
                       maxlength="24"/>
            </div>
            <div class="form-group col-sm-12">
                <input type="text" v-model.lazy="cancellation.bic" class="form-control input-gray"
                       :required="requireInput"
                       :placeholder="$t('Generic.bic')"
                       :aria-label="$t('Generic.bic')"
                       maxlength="30"/>
            </div>
        </div>
    </DetailsSection>
</template>

<script>
    import DetailsSection from '@/components/DetailsSection';

    export default {
        name: 'BankAccountData',
        components: {
            DetailsSection
        },
        data() {
            return {
            };
        },
        props: {
            cancellation: {
                type: Object,
                required: true
            }
        },
        computed: {
            requireInput() {
                return (this.cancellation.firstname !== '' || this.cancellation.lastname !== '' || this.cancellation.iban !== '' || this.cancellation.bic !== '');
            }
        }
    }
</script>

<style scoped>

</style>
